import React from "react";
import {
  HeaderBoxContainer,
  HeaderBoxContent,
  HeaderBoxTitle,
} from "./HeaderBox.styles";

export const HeaderBox = ({ title, children }) => (
  <HeaderBoxContainer>
    <HeaderBoxTitle variant="h6">{title}</HeaderBoxTitle>
    <HeaderBoxContent>{children}</HeaderBoxContent>
  </HeaderBoxContainer>
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/HeaderBox/HeaderBox.js